// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReactContext$LiveRoom from "../ReactContext.bs.js";

var defaultState = {
  position: /* Floating */0,
  floatingStreamContainerHeight: 0
};

function defaultValue_1(param) {
  
}

var defaultValue = [
  defaultState,
  defaultValue_1
];

var Context = ReactContext$LiveRoom.Make({
      defaultValue: defaultValue
    });

function reducerFn(state, action) {
  if (typeof action !== "number") {
    return {
            position: state.position,
            floatingStreamContainerHeight: action._0
          };
  }
  if (action === 0) {
    return {
            position: /* Floating */0,
            floatingStreamContainerHeight: state.floatingStreamContainerHeight
          };
  }
  switch (action) {
    case /* CenterStream */1 :
        return {
                position: /* FrontAndCenter */1,
                floatingStreamContainerHeight: state.floatingStreamContainerHeight
              };
    case /* CloseStream */2 :
        return {
                position: /* Closed */2,
                floatingStreamContainerHeight: state.floatingStreamContainerHeight
              };
    case /* ShowStream */3 :
        return {
                position: /* Floating */0,
                floatingStreamContainerHeight: state.floatingStreamContainerHeight
              };
    
  }
}

function LiveStream$Provider(props) {
  var match = React.useReducer(reducerFn, defaultState);
  return React.createElement(Context.Provider.make, {
              value: [
                match[0],
                match[1]
              ],
              children: props.children
            });
}

var Provider = {
  make: LiveStream$Provider
};

export {
  defaultState ,
  Context ,
  reducerFn ,
  Provider ,
}
/* Context Not a pure module */
